import { RADIO, TEXTAREA } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';

/**
 * Cart submission requires the cart to have a certain data layout. Lets massage it here.
 *
 * @param cartData - users current cart selections
 */
export function normalizeDataForCart(cartData = []) {
  return cartData.map((lineItem) => {
    if ([RADIO, TEXTAREA].includes(lineItem.answerType)) {
      const [first] = lineItem.answers;
      return { ...lineItem, answers: first };
    }
    return lineItem;
  });
}

/**
 *
 * @param id - answer ID
 * @param data - Current Question object
 */
export const getQADataById = ({ callbackValue, currentQuestionFlow, currentGroup }) => {
  // we can get a varied answerObj, ie. id, [id's], {id}, lets get it in an iterable form
  const answersObj = [].concat(...[callbackValue]).filter(Boolean);
  // question id
  const qid = currentQuestionFlow.id;
  const { complete } = currentQuestionFlow;
  return answersObj.reduce(
    (outerAccum, outerAnswer) => {
      // can't reassign with these lint settings.
      const outerAccumCopy = { ...outerAccum };
      // If we have an array of objects, we need to get at the id, else it will just be an id
      const id = isPlainObject(outerAnswer) ? outerAnswer.id : outerAnswer;
      // simple helper for a reasonable default value
      const deriveValue = (answer) => answer.value || outerAnswer.value || '';

      // we now push our answer in the answers array that is part of the overall answer/question user selection
      // answers are contained within children of questions object that is created in the skuData
      currentQuestionFlow.children[currentGroup].forEach((answer) => {
        // Find a match for our current answer
        // eslint-disable-next-line
        if (answer.id == id) {
          const value = deriveValue(answer);
          const text = get(callbackValue, 'text', '');
          outerAccumCopy.answers.push({ ...answer, value, text });
        }
        // If our answer has children, used for dropdowns.
        if (answer.children) {
          answer.children.forEach((a) => {
            // eslint-disable-next-line eqeqeq
            if (a.id == id) {
              const value = deriveValue(a);
              outerAccumCopy.answers.push({ ...a, value });
            }
          });
        }
      });
      return outerAccumCopy;
    },
    { qid, complete, answers: [], answerType: currentQuestionFlow.answerType },
  );
};
